import { getConstant } from '../utils';

export const getSellers = getConstant('GET_SELLERS');
export const getSeller = getConstant('GET_SELLER');
